import React, { useState, useEffect } from 'react'
import { useTheme } from "../../../Themecontext/Themecontext";
import MillstageDropDownFilter from "../../../components/FilterBox/Millstage/MillstageDropDownFilter";
import { useSelector, useDispatch } from 'react-redux';
import { Row, Col, Button, Offcanvas, Modal } from "react-bootstrap";
import MillstageTable from "../../../components/Tables/MillstageTable";
import Input from '../../../components/FilterBox/Millstage/Input';
import Millstagetablecruad from '../../../components/Tables/Millstagetablecruad';
import {
    AllFilter,
    ProcessTypeShowAll,
    ProcessTypeShowOne,
    ProcessTypeInsert,
    ProcessTypeUpdate,
    ProcessTypeDelete
} from '../../../Redux/Slice/MillstageEntry/MillstageEntrySlice';
import { toast } from "react-toastify";
import { Loader } from '../../../components/Loader/Loader';

const TransProcessType = () => {
    const dispatch = useDispatch();

    const { Colourdata } = useSelector((state) => state.ClientLogin);
    const {
        AllFilterdata,
        ProcessTypeShowAlldata,
        ProcessTypeShowOnedata,
        loading
    } = useSelector((state) => state.MillstageEntry || {});

    useEffect(() => {
        dispatch(AllFilter({}));
        dispatch(ProcessTypeShowAll({}));
    }, [dispatch]);

    const iscolour = Colourdata?.data?.find(
        (el) => el.ExeName === "NEWMILLSTAGE",
    );
    const iscolourDark = Colourdata?.data?.find(
        (el) => el.ExeName === "NEWMILLSTAGEDARK",
    );
    const { theme } = useTheme();
    const isdark = theme;

    const [processMaster, setProcessMaster] = useState("");
    const [shName, setShName] = useState("");
    const [transactionTypeSearch, setTransactionTypeSearch] = useState("");
    const [transactionTypeId, setTransactionTypeId] = useState([]);
    const [isBatchFilter, setIsBatchFilter] = useState(false);

    const [showForm, setShowForm] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [editMainId, setEditMainId] = useState(null);

    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [confirmAction, setConfirmAction] = useState(null);
    const [rowToDelete, setRowToDelete] = useState(null);

    const TransTypeList =
        AllFilterdata?.TransType?.filter((item) => item?.TransProc === true)
            .map((item) => ({
                label: item?.TTName,
                value: item?.TransTypeID,
            })) || [];

    const TableColumns = [
        {
            label: "Sr. No.",
            key: "srNumber",
            align: "center",
        },
        {
            label: "Process Type",
            key: "ProcessType",
            align: "left",
        },
        {
            label: "Process Time",
            key: "ProcessTime",
            align: "left",
        },
        {
            label: "Is Batch Filter",
            key: "IsBatchFilter",
            align: "center",
        }
    ];

    const formatTime = (isoString) => {
        if (!isoString) return "";
        const date = new Date(isoString);
        if (isNaN(date.getTime())) return isoString;
        const hours = date.getUTCHours().toString().padStart(2, '0');
        const minutes = date.getUTCMinutes().toString().padStart(2, '0');
        return `${hours}:${minutes}`;
    };

    const TableRows = (ProcessTypeShowAlldata?.Data || []).map((row) => ({
        ProcessType: row?.ProcessType ?? "",
        ProcessTime: formatTime(row?.ProcessTime),
        IsBatchFilter: row?.IsBatchFilter ? "Yes" : "No",
        ProcessId: row?.ProcessId ?? "",
        ProcessTypeID: row?.ProcessTypeID
    }));

    const handleEdit = (row) => {
        const matchedRow = ProcessTypeShowAlldata?.Data?.find(
            item => item.ProcessTypeID === row.ProcessTypeID
        );

        if (!matchedRow) return;

        setEditMainId(matchedRow.ProcessTypeID);

        setIsBatchFilter(matchedRow.IsBatchFilter === true || matchedRow.IsBatchFilter === 1 || matchedRow.IsBatchFilter === "1" || matchedRow.IsBatchFilter === "true" || matchedRow.IsBatchFilter === "Yes");

        dispatch(
            ProcessTypeShowOne({
                MainID: matchedRow.ProcessTypeID
            })
        );

        setIsEditMode(true);
        setShowForm(true);
    };

    const handleDelete = (row) => {
        setRowToDelete(row);
        setConfirmAction("delete");
        setShowConfirmModal(true);
    };

    const executeDelete = async () => {
        const matchedRow = ProcessTypeShowAlldata?.Data?.find(
            item => item.ProcessTypeID === rowToDelete?.ProcessTypeID
        );

        if (!matchedRow) {
            setShowConfirmModal(false);
            return;
        }

        const result = await dispatch(
            ProcessTypeDelete({
                MainID: matchedRow.ProcessTypeID
            })
        );

        if (ProcessTypeDelete.fulfilled.match(result)) {
            if (result.payload?.status === "done" || result.payload?.status === "Record Deleted Successfully") {
                toast.success("Record Deleted Successfully");
            } else {
                toast.error(result.payload?.status);
            }
            await dispatch(ProcessTypeShowAll({}));
        } else {
            toast.error(result.payload?.status || "Delete Failed");
        }
        setShowConfirmModal(false);
        setRowToDelete(null);
    };

    useEffect(() => {
        if (!ProcessTypeShowOnedata?.Data?.length) return;

        const data = ProcessTypeShowOnedata.Data;
        const firstRow = data[0];
        setProcessMaster(firstRow.ProcessType || "");
        setShName(formatTime(firstRow.ProcessTime));

        const validTrans = data.filter(
            item => item.TransTypeID && item.TTName
        );

        if (validTrans.length > 0) {
            setTransactionTypeId(validTrans.map(item => item.TransTypeID));
            setTransactionTypeSearch(validTrans.map(item => item.TTName));
        } else {
            setTransactionTypeId([]);
            setTransactionTypeSearch([]);
        }

    }, [ProcessTypeShowOnedata]);

    const handleSubmit = async () => {
        if (!processMaster || !processMaster.trim()) {
            toast.warning("Process Type cannot be empty!");
            return;
        }

        if (isEditMode) {
            setConfirmAction("update");
            setShowConfirmModal(true);
        } else {
            const master = {
                ProcessType: processMaster,
                ProcessTime: shName || "00:00",
                IsBatchFilter: isBatchFilter ? 1 : 0,
            };

            const detail = transactionTypeId.map((id) => ({
                TransTypeID: id
            }));

            const result = await dispatch(
                ProcessTypeInsert({
                    master,
                    detail
                })
            );

            if (ProcessTypeInsert.fulfilled.match(result)) {
                if (result.payload?.status === "done" || result.payload?.status === "Record Inserted Successfully") {
                    toast.success("Record Inserted Successfully");
                    await dispatch(ProcessTypeShowAll({}));

                    // Reset form
                    setProcessMaster("");
                    setShName("");
                    setIsBatchFilter(false);
                    setTransactionTypeId([]);
                    setTransactionTypeSearch("");

                    setShowForm(false);
                } else {
                    toast.error(result.payload?.status);
                }
            } else {
                toast.error(result.payload?.status || "Insert Failed");
            }
        }
    };

    const executeUpdate = async () => {
        const master = {
            ProcessType: processMaster,
            ProcessTime: shName || "00:00",
            IsBatchFilter: isBatchFilter ? 1 : 0,
        };

        const detail = transactionTypeId.map((id) => {
            const oldItem = ProcessTypeShowOnedata?.Data?.find(
                item => item.TransTypeID === id
            );
            return {
                TransTypeID: id,
                TransTypeProcessTypeID: oldItem?.TransTypeProcessTypeID || 0
            };
        });

        const result = await dispatch(
            ProcessTypeUpdate({
                MainID: editMainId,
                master,
                detail
            })
        );

        if (ProcessTypeUpdate.fulfilled.match(result)) {
            if (result.payload?.status === "done" || result.payload?.status === "Record Updated Successfully") {
                toast.success(result.payload?.status);
            } else {
                toast.error(result.payload?.status);
            }
            await dispatch(ProcessTypeShowAll({}));
            setShowForm(false);
            setIsEditMode(false);
        } else {
            toast.error(result.payload?.status || "Update Failed");
        }
        setShowConfirmModal(false);
    };

    return (
        <div
            style={{
                background: isdark === "light" ? "#FFF9F5" : iscolourDark?.Colour10,
                minHeight: "100vh",
                padding: "16px",
            }}
        >
            {loading && <Loader />}
            <div className="d-flex justify-content-end  mb-3">
                <button
                    onClick={() => {
                        setShowForm(true);
                        setIsEditMode(false);
                        setProcessMaster("");
                        setShName("");
                        setIsBatchFilter(false);
                        setTransactionTypeId([]);
                        setTransactionTypeSearch("");
                    }}
                    style={{
                        background:
                            isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour5,
                        color:
                            isdark === "light" ? iscolour?.Colour9 : iscolourDark?.Colour1,
                        border: "none",
                        padding: "8px 16px",
                        borderRadius: "8px",
                        fontWeight: "600",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                    }}
                >
                    + New Master
                </button>
            </div>

            {showForm && (
                <div
                    style={{
                        background: isdark === "light" ? "#fff" : iscolourDark?.Colour10,
                        padding: "15px",
                        borderRadius: "12px",
                        border: `2px solid ${isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour7}`,
                        marginBottom: "20px",
                    }}
                >
                    {/* Header */}
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "12px",
                            marginBottom: "20px",
                            paddingBottom: "12px",
                            borderBottom: "1px solid #E5E7EB",
                        }}
                    >
                        <div
                            style={{
                                width: "36px",
                                height: "36px",
                                borderRadius: "50%",
                                background: isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour7,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: isdark === "light" ? iscolour?.Colour9 : "#fff",
                                fontSize: "18px",
                                fontWeight: "600",
                            }}
                        >
                            ✦
                        </div>

                        <div>
                            <h6
                                style={{
                                    margin: 0,
                                    fontWeight: "700",
                                    color: isdark === "light" ? iscolour?.Colour9 : "#fff",
                                }}
                            >
                                {isEditMode ? "Update Trans Process Type" : "New Trans Process Type"}
                            </h6>

                            <small
                                style={{
                                    color: "#8B95A7",
                                    fontSize: "13px",
                                }}
                            >
                                Fill in the process details below
                            </small>
                        </div>
                    </div>

                    <Row className="g-2 align-items-end ">
                        <Col xs={12} sm={12} md={6} lg={6} xl={3} className="pb-2 pb-md-0">
                            <Input
                                label="Process Type"
                                placeholder="Enter Process Type"
                                value={processMaster}
                                onChange={(e) => setProcessMaster(e.target.value)}
                                required
                                isdark={isdark}
                                iscolour={iscolour}
                                iscolourDark={iscolourDark}
                            />
                        </Col>

                        <Col xs={12} sm={12} md={6} lg={6} xl={3} className="pb-2 pb-md-0">
                            <Input
                                label="Process Time"
                                type="time"
                                placeholder="Process Time"
                                value={shName}
                                onChange={(e) => setShName(e.target.value)}
                                required
                                isdark={isdark}
                                iscolour={iscolour}
                                iscolourDark={iscolourDark}
                            />
                        </Col>

                        <Col
                            xs={12}
                            sm={12}
                            md={6}
                            lg={6}
                            xl={2}
                            className="pb-2 pb-md-0 d-flex align-items-center justify-content-center"
                        >
                            <Input
                                type="checkbox"
                                label="Is Batch Filter"
                                name="batchFilter"
                                checked={isBatchFilter}
                                onChange={() => setIsBatchFilter(!isBatchFilter)}
                                isdark={isdark}
                                iscolour={iscolour}
                                iscolourDark={iscolourDark}
                            />
                        </Col>

                        <Col xs={12} sm={12} md={6} lg={6} xl={2} className="pb-2 pb-md-0">
                            <MillstageDropDownFilter
                                label="Trans Type"
                                data={TransTypeList}
                                selectedValue={transactionTypeSearch}
                                setSelectedValue={setTransactionTypeSearch}
                                selectedId={transactionTypeId}
                                setSelectedId={setTransactionTypeId}
                                placeholder="Select Trans Type"
                                isdark={isdark}
                                iscolour={iscolour}
                                iscolourDark={iscolourDark}
                            />
                        </Col>

                        {/* BUTTON */}
                        <Col xs={12} sm={12} md={6} lg={6} xl={2}>
                            <button
                                onClick={handleSubmit}
                                style={{
                                    padding: "12px",
                                    backgroundColor:
                                        isdark === "light"
                                            ? iscolour?.Colour8
                                            : iscolourDark?.Colour4,
                                    color:
                                        isdark === "light"
                                            ? iscolour?.Colour1
                                            : iscolourDark?.Colour1,
                                    width: "100%",
                                    borderRadius: "12px",
                                    fontWeight: "700",
                                    border: "none",
                                }}
                            >
                                {isEditMode ? "Update" : "Submit"}
                            </button>
                        </Col>
                    </Row>
                </div>
            )}

            <div
                style={{
                    background: isdark === "light" ? "#fff" : iscolourDark?.Colour10,
                    borderRadius: "12px",
                    overflow: "hidden",
                    border: `1px solid ${isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour8}`,
                }}
            >
                <div
                    style={{
                        padding: "15px 20px",
                        borderBottom: `1px solid ${isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour8}`,
                        background: isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour8,
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                >
                    <h6
                        style={{
                            margin: 0,
                            color: isdark === "light" ? "#fff" : "#fff",
                            fontWeight: "600",
                        }}
                    >
                        Trans Process Types
                    </h6>
                </div>

                <div style={{ padding: "0" }}>
                    <Millstagetablecruad
                        columns={TableColumns}
                        data={TableRows}
                        showActions={true}
                        showTotalRow={false}
                        onEdit={handleEdit}
                        onDelete={handleDelete}
                    />
                </div>
            </div>

            {/* Confirmation Modal */}
            <Modal show={showConfirmModal} onHide={() => setShowConfirmModal(false)} centered>
                <Modal.Header closeButton style={{ background: isdark === "light" ? "#f8f9fa" : "#1e293b", color: isdark === "light" ? "#000" : "#fff", borderBottom: `1px solid ${isdark === "light" ? "#e5e7eb" : "#334155"}` }}>
                    <Modal.Title style={{ fontSize: "18px", fontWeight: "600" }}>Confirm Action</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ background: isdark === "light" ? "#fff" : "#0f172a", color: isdark === "light" ? "#333" : "#cbd5e1" }}>
                    Are you sure you want to {confirmAction} this record?
                </Modal.Body>
                <Modal.Footer style={{ background: isdark === "light" ? "#f8f9fa" : "#1e293b", borderTop: `1px solid ${isdark === "light" ? "#e5e7eb" : "#334155"}` }}>
                    <Button variant="secondary" onClick={() => setShowConfirmModal(false)}>
                        Cancel
                    </Button>
                    <Button
                        variant={confirmAction === "delete" ? "danger" : "primary"}
                        onClick={confirmAction === "delete" ? executeDelete : executeUpdate}
                    >
                        Yes, {confirmAction === "delete" ? "Delete" : "Update"}
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default TransProcessType;